/** @file The loop length a walk cycle uses when `frames` is not given: 0.8 s at the document fps. */
import type { Doc } from '@pose2d/format/types';

/** Mirrors the analysis' own default (`max(8, round(fps * 0.8))`), clamped to `range`, so the field shows what a run uses. */
export function frameDefault(doc: Doc, range: readonly [number, number]): number {
  return Math.min(range[1], Math.max(range[0], Math.round(doc.meta.fps * 0.8)));
}
